import React, { ReactElement, useEffect, useState } from 'react';
import CarouselComponent from 'components/common/Carousel';
import { Button } from 'components/common/Button';
import CartContentsMessage from 'components/common/CartContentsMessage';
import { useRecoilValue } from 'recoil';
import { cartState } from 'app-state/cart-state';
import { Product } from 'utils/Product';
import ProductTile from 'components/common/ProductTile';
import ReactLoading from 'react-loading';
import { useVisibleProducts } from 'app-state/product-cache';

const selectNRandomItems = (array: Product[], numItems: number): Product[] => {
  const maxItemsToSelect = Math.min(array.length, numItems);
  const selectedIndices: number[] = [];

  for (let i = 0; i < maxItemsToSelect; i += 1) {
    let index = Math.floor(Math.random() * (array.length - selectedIndices.length));
    // Exclude already-selected items by navigating along the list until we find a product
    // that is not in the selected indices.
    while (selectedIndices.includes(index)) index = (index + 1) % array.length;
    selectedIndices.push(index);
  }

  return selectedIndices.map(index => array[index]);
};

const HomePage = (): ReactElement => {
  const { status, products: allProducts } = useVisibleProducts();
  const [topProducts, setTopProducts] = useState<Product[] | undefined>(undefined);
  const { cartItemCount } = useRecoilValue(cartState);

  useEffect(() => {
    if ((status === 'Ok' || status === 'Stale') && allProducts) setTopProducts(selectNRandomItems(allProducts, 3));
  }, [status]);

  return (
    <div className='w-5/6 m-auto my-8 max-w-7xl'>
      <CarouselComponent />
      <div className='py-4 my-8 h-24'>
        {cartItemCount == 0
          ? <Button primary id='start-shopping-button' className='p-4 leading-4' linkTo='/shop'>
              Start Shopping <span className='text-lg'>&#8594;</span></Button>
          : <CartContentsMessage button />
        }
      </div>
      <h1 className='text-2xl m-6 font-bold'>Popular Items Right Now!!!</h1>
      {!topProducts && <ReactLoading className='m-auto' type={'bubbles'} color={'#ac542e'} height={'50%'} width={'10%'} />}
      <div className='grid grid-cols-3 mx-auto max-w-4xl text-base font-medium leading-6'>
        {topProducts && topProducts.map((product: Product) => <ProductTile key={product.id} product={product} />)}
      </div>
    </div>
  );
};

export default HomePage;
